// ─────────────────────────────────────────────
// KLOTHIQ — Purchase Zod Schemas
// ─────────────────────────────────────────────

import { z } from 'zod';
import { PurchaseStatus } from '@klothiq/domain';
import { moneySchema, moneyOrZeroSchema, quantitySchema, dateSchema } from './common.schema';

export const purchaseItemFormSchema = z.object({
  variant_id: z.string().uuid('Select a product variant'),
  quantity: quantitySchema,
  unit_cost: moneySchema,
  discount: moneyOrZeroSchema,
});

export const purchaseFormSchema = z.object({
  supplier_id: z.string().uuid('Select a supplier'),
  purchase_date: dateSchema,
  expected_date: dateSchema.nullable().optional(),
  supplier_invoice_no: z.string().max(100).nullable().optional(),
  status: z.nativeEnum(PurchaseStatus).default(PurchaseStatus.DRAFT),
  other_charges: moneyOrZeroSchema,
  notes: z.string().max(1000).nullable().optional(),
  items: z.array(purchaseItemFormSchema).min(1, 'At least one item is required'),
});

export const receivePurchaseSchema = z.object({
  purchase_id: z.string().uuid(),
  received_date: dateSchema,
  items: z.array(
    z.object({
      purchase_item_id: z.string().uuid(),
      received_quantity: z.number().int().min(0, 'Cannot be negative'),
    }),
  ),
});

export type PurchaseItemFormValues = z.infer<typeof purchaseItemFormSchema>;
export type PurchaseFormValues = z.infer<typeof purchaseFormSchema>;
export type ReceivePurchaseValues = z.infer<typeof receivePurchaseSchema>;
